import React,{useContext} from 'react'
import themeContext from '../../../../context/theme/ThemeContext';

const UploadStudyTab = (props) => {

  const { getThemeColor } = useContext(themeContext);

    return (
      <>
      <div className={props.contentClass}>
          <h4
          className={`textContent-study-list`}
          style={{margin:'0px',color: getThemeColor("primary-color")}}
        >
          {props.title}
        </h4>
        {props.active && <div style={{ backgroundColor:getThemeColor("modal-body") }} className="hide-border-bottom-border-tabs"></div>}
      </div>
      </>
    );
  };

export default UploadStudyTab